import { render, staticRenderFns } from "./Tab9ParticipantSignatures.vue?vue&type=template&id=1606a006&scoped=true"
import script from "./Tab9ParticipantSignatures.vue?vue&type=script&lang=js"
export * from "./Tab9ParticipantSignatures.vue?vue&type=script&lang=js"
import style0 from "./Tab9ParticipantSignatures.vue?vue&type=style&index=0&id=1606a006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606a006",
  null
  
)

export default component.exports